// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__FvfBK","file":"styles_file__1bw_j"};